import { useTypedSelector } from 'state';

export const useCurrentSpot = () => {
  const spotId = useTypedSelector(state => state.application.spotId);
  const spot = useTypedSelector(state => state.spots.map[spotId]);

  return spot;
};
